import type { PayloadAction } from '@reduxjs/toolkit';
import type { ObjectivesState } from './types';

import { createSlice } from '@reduxjs/toolkit';

const initialState: ObjectivesState = {
  selected_objective_id: null,
};

const objectivesSlice = createSlice({
  name: 'objectives',
  initialState,
  reducers: {
    setSelectedObjectiveId: (state, action: PayloadAction<string | null>) => {
      state.selected_objective_id = action.payload;
    },
    clearSelectedObjectiveId: (state) => {
      state.selected_objective_id = null;
    },
  },
});

export const { setSelectedObjectiveId, clearSelectedObjectiveId } = objectivesSlice.actions;

export default objectivesSlice.reducer;
